import { render, staticRenderFns } from "./CasesManagement.vue?vue&type=template&id=388a485e&scoped=true&"
import script from "./CasesManagement.vue?vue&type=script&lang=js&"
export * from "./CasesManagement.vue?vue&type=script&lang=js&"
import style0 from "./CasesManagement.vue?vue&type=style&index=0&id=388a485e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a485e",
  null
  
)

export default component.exports